<!------------------------------------------- template ------------------------------------------->
<template>
  <div class="page">
    <div class="banner container"></div>
    <div class="top_title">
      <div v-for="item in titleList" :key="item.id" class="top_box">
        <div class="title_box">{{ item.title }}</div>
        <div class="btn_box">{{ item.btn }}</div>
      </div>
    </div>
    <div class="content_container">
      <div v-for="(item,i) in contentList" :key="item.id" class="content_box">
        <div class="content_title content_con1" :class="{'content_con2': i == contentList.length - 1,'content_title1':item.title === '系统功能','content_title2':item.title === '技术支持'}">{{ item.title }}</div>
        <div class="content_con content_con1" :class="{'content_con2': i == contentList.length - 1}">
          <div v-for="item1 in item.list1" :key="item1.id">
            <span :class="{'con_blue':item1.blue}">{{ item1.label }}</span>
            <img src="../assets/img/green-dui.png" alt="">
          </div>
        </div>
        <div class="content_con content_con1" :class="{'content_con2': i == contentList.length - 1}">
          <div v-for="item2 in item.list2" :key="item2.id">
            <span :class="{'con_blue':item2.blue}">{{ item2.label }}</span>
            <img src="../assets/img/green-dui.png" alt="">
          </div>
        </div>
        <div class="content_con">
          <div v-for="item3 in item.list3" :key="item3.id">
            <span :class="{'con_blue':item3.blue}">{{ item3.label }}</span>
            <img src="../assets/img/green-dui.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-------------------------------------------- script -------------------------------------------->
<script>
export default {
  name: '',
  components: {},

  data() {
    return {
      titleList: [
        {
          id: 1,
          title: '',
          btn: '',
        },
        {
          id: 2,
          title: '标准版 (SaaS版)',
          btn: '永久免费',
        },
        {
          id: 3,
          title: '企业版',
          btn: '私有化部署',
        },
        {
          id: 4,
          title: '定制版',
          btn: '定制开发',
        },
      ],
      contentList: [
        {
          id: 1,
          title: '系统功能',
          list1: [
            {
              id: 11,
              label: '市场运营管理系统',
              blue: false,
            },
            {
              id: 12,
              label: '市场管理APP',
              blue: false,
            },
            {
              id: 13,
              label: '商户APP、小程序',
              blue: false,
            },
            {
              id: 14,
              label: '结算系统（支持统一结算）',
              blue: false,
            },
            {
              id: 15,
              label: '智能设备物联网接入系统 ',
              blue: false,
            }
          ],
          list2: [
            {
              id: 21,
              label: '市场运营管理系统',
              blue: false,
            },
            {
              id: 22,
              label: '市场管理APP',
              blue: false,
            },
            {
              id: 23,
              label: '商户APP、小程序',
              blue: false,
            },
            {
              id: 24,
              label: '结算系统（支持统一结算）',
              blue: false,
            }, {
              id: 25,
              label: '智能设备物联网接入系统',
              blue: false,
            }, {
              id: 26,
              label: '仓储冷库管理系统',
              blue: true,
            }, {
              id: 27,
              label: 'B2B生鲜电商系统',
              blue: true,
            },
          ],
          list3: [
            {
              id: 31,
              label: '支持企业版数据功能',
              blue: false,
            },
            {
              id: 32,
              label: '支持客户业务流程定制开发',
              blue: true,
            },
            {
              id: 33,
              label: '支持各功能定制开发',
              blue: true,
            },
            {
              id: 34,
              label: '支持私有化部署',
              blue: true,
            },
            {
              id: 35,
              label: '支持源代码交付',
              blue: true,
            },
          ],
        },
        {
          id: 22,
          title: '市场数量',
          list1: [
            {
              id: 111,
              label: '单个市场',
              blue: false,
            },
          ],
          list2: [
            {
              id: 221,
              label: '无任何限制',
              blue: false,
            },
          ],
          list3: [],
        },
        {
          id: 33,
          title: '商户数量',
          list1: [
            {
              id: 311,
              label: '500户',
              blue: false,
            },
          ],
          list2: [
            {
              id: 321,
              label: '不限制商户数量',
              blue: false,
            },
          ],
          list3: [],
        },
        {
          id: 44,
          title: '物联网设备接入数量',
          list1: [
            {
              id: 411,
              label: '1000台',
              blue: false,
            },
          ],
          list2: [
            {
              id: 421,
              label: '不限制设备数量',
              blue: false,
            },
          ],
          list3: [],
        },
        {
          id: 55,
          title: '数据储存空间',
          list1: [
            {
              id: 511,
              label: '500G',
              blue: false,
            },
          ],
          list2: [
            {
              id: 521,
              label: '无任何限制',
              blue: false,
            },
          ],
          list3: [],
        },
        {
          id: 66,
          title: '系统部署',
          list1: [
            {
              id: 611,
              label: '公网SaaS版',
              blue: false,
            },
          ],
          list2: [
            {
              id: 621,
              label: '公网SaaS版',
              blue: false,
            },
            {
              id: 622,
              label: '私有化部署',
              blue: true,
            },
          ],
          list3: [],
        },
        {
          id: 77,
          title: '系统构架',
          list1: [
            {
              id: 711,
              label: '前后端分离 独立数据库',
              blue: false,
            },
          ],
          list2: [
            {
              id: 721,
              label: '前后端分离',
              blue: false,
            },
            {
              id: 722,
              label: '主备数据库',
              blue: true,
            },
            {
              id: 723,
              label: '服务器负载均衡',
              blue: true,
            },
            {
              id: 724,
              label: '200M专用独立公网接入',
              blue: true,
            },
          ],
          list3: [],
        },
        {
          id: 88,
          title: '技术支持',
          list1: [
            {
              id: 811,
              label: '免费升级',
              blue: false,
            },
            {
              id: 812,
              label: '在线技术支持',
              blue: false,
            },
            {
              id: 813,
              label: '服务时间: 工作日9:00-18:00',
              blue: false,
            },
          ],
          list2: [
            {
              id: 821,
              label: '免费升级',
              blue: false,
            },
            {
              id: 822,
              label: '现场技术支持',
              blue: true,
            },
            {
              id: 823,
              label: '一对一专家服务',
              blue: true,
            },
            {
              id: 824,
              label: '服务时间: 7*24小时',
              blue: true,
            },
          ],
          list3: [],
        },
      ],
    }
  },

  /* 一.生命周期函数 */
  created() {
  },

  /* 二.监控函数 */
  watch: {},

  computed: {},

  /* 三.内部功能函数 */
  methods: {}
}
</script>

<!--------------------------------------------- style -------------------------------------------->
<style scoped>
.banner {
  background: url("../assets/img/banner_cpdj@2x.png") no-repeat center center;
  background-size: cover;
  height: 600px;
  margin-bottom: 50px;
}

.top_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
}

.top_title .top_box:nth-child(1) {
  width: 204px;
}

.top_title .top_box:nth-child(2),
.top_title .top_box:nth-child(3),
.top_title .top_box:nth-child(4) {
  width: 316px;
  height: 122px;
  text-align: center;
  padding-top: 24px;
  font-size: 22px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
  box-sizing: border-box;
  cursor: pointer;
}

.top_title .top_box:nth-child(2) {
  background: #A1C4FF;
  border-radius: 12px 12px 0px 0px;
}

.top_title .top_box:nth-child(3) {
  background: #C2B3F7;
  border-radius: 12px 12px 0px 0px;
}

.top_title .top_box:nth-child(4) {
  background: #FFCA9C;
  border-radius: 12px 12px 0px 0px;
}

.top_box .btn_box:nth-child(2),
.top_box .btn_box:nth-child(3),
.top_box .btn_box:nth-child(4) {
  width: 108px;
  padding: 6px 0;
  box-sizing: border-box;
  margin: 14px auto 0;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  background: #FFFFFF;
  border-radius: 18px;
}

.top_box .btn_box:nth-child(2) {
  color: #5F96F5;
}

.top_box .btn_box:nth-child(2) {
  color: #9B80F4;
}

.top_box .btn_box:nth-child(2) {
  color: #FDAA61;
}

.content_box {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
}

.content_title{
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #6D7278;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content_box .content_title:nth-child(1) {
  width: 204px;
  background: #F5F5F5;
}

.content_con {
  width: 332px;
  padding: 22px 40px 9px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  box-sizing: border-box;
}

.content_con div {
  margin-bottom: 11px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.content_con img {
  width: 28px;
  height: 28px;
}

.con_blue{
  font-weight: 500;
  color: #1843DB;
}

.content_con1{
  border-bottom: 2px solid rgba(138, 138, 138, 0.25);
}

.content_con2{
  border-bottom: none;
}

.content_title1{
  border-radius: 12px 12px 0 0;
}
.content_title2{
  border-radius: 0 0 12px 12px;
}

.content_container{
  margin-bottom: 61px;
}
</style>
